import { graphql } from "relay-runtime"

export const chGeneralAttestationsFragment = graphql`
  fragment chGeneralAttestationsFragment on ch_GeneralAttestation {
    id
    fileId
    language
    progressNoteId
    name
    message
    subject
    signedAt
    signedBy
    updatedAt
    updatedBy
    createdAt
    createdBy
    sentAt
    sentBy
    concludedAt
    concludedBy
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
  }
`
